module.exports = __webpack_public_path__ + "4e871bb31faeb0e29f07fc4c11e60fb1.fbx";